module.exports = __webpack_public_path__ + "media/images/home-gradient-background-728c7bce1ddeea24883b022c037973c8.png";